import { Parameter } from "domain/entities/parameter";
import { BaseInputFilter } from "domain/models/base-input-filter";
import { useParameterByFilter } from "presentation/hooks/use-query-parameter";
import { useParameterStore } from "presentation/stores/use-parameter-store";
import { ColumnFilterElementTemplateOptions } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";

const TypePurchaseOrderDropdown: React.FC<{
  options: ColumnFilterElementTemplateOptions;
}> = ({ options }) => {
  const [PurchaseOrderTypeOptions, setPurchaseOrderTypeOptions] = useState<
    { label: string; value: string }[]
  >([]);

  const { purchaseOrderType, setPurchaseOrderType } = useParameterStore();

  const { data: parameters } = useParameterByFilter({
    limit: 1000,
    sortBy: "value",
  } as BaseInputFilter);

  useEffect(() => {
    setPurchaseOrderType(
      parameters?.data?.filter((item) => item.type === "purchaseOrderType")
    );
  }, [parameters]);

  useEffect(() => {
    setPurchaseOrderTypeOptions(
      purchaseOrderType.map((item: Parameter) => ({
        label: item.value,
        value: item.value,
      }))
    );
  }, [purchaseOrderType]);

  return (
    <Dropdown
      value={options.value}
      options={PurchaseOrderTypeOptions}
      onChange={(e) => options.filterCallback(e.value)}
      placeholder="Selecione o tipo"
      showClear
    />
  );
};
export default TypePurchaseOrderDropdown;
